import { Suspense, lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import { Spin } from 'antd';

// Lazy load views for code splitting
const ReportStudioView = lazy(() => import('./views/ReportStudioView'));
const ReportViewerView = lazy(() => import('./views/ReportViewerView'));

const LoadingFallback = () => (
  <div className="min-h-screen flex items-center justify-center">
    <Spin size="large" tip="Loading..." />
  </div>
);

export const reportRoutes: RouteObject[] = [
  {
    path: 'reports',
    children: [
      {
        index: true,
        element: (
          <Suspense fallback={<LoadingFallback />}>
            <ReportStudioView />
          </Suspense>
        ),
      },
      {
        path: 'studio',
        element: (
          <Suspense fallback={<LoadingFallback />}>
            <ReportStudioView />
          </Suspense>
        ),
      },
      {
        path: 'view/:reportCode',
        element: (
          <Suspense fallback={<LoadingFallback />}>
            <ReportViewerView />
          </Suspense>
        ),
      },
    ],
  },
];

export default reportRoutes;
